module.exports = __webpack_public_path__ + "c95fb590abe8c21db7f1a1c1513abf35.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/banners/parlam_ru.jpg
// module id = 270
// module chunks = 0